module.exports = __webpack_public_path__ + "img/Palettenblock.1c84ebc.svg";